import React from 'react';
// @ts-ignore
import Modal from '../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import { Size } from '../../../Enums/Size.enum';
import ElectronicPrescriptionDetailWrapper from '../../Prescription/Components/ElectronicPrescriptionDetail/ElectronicPrescriptionDetailWrapper';
import ElectronicPrescriptionCloseButton from './ElectronicPrescriptionCloseButton';

interface ElectronicPrescriptionModalProps {
	opened: boolean;
	onClose?: () => void;
	onCreate?: () => void;
	patientId: string;
	defaultValues?: any;
	attachToDiscourse?: boolean;
	createDekurz?: boolean;
	discardOnClose?: boolean;
}

export default function ElectronicPrescriptionModal(
	props: ElectronicPrescriptionModalProps,
) {
	const {
		opened,
		onClose,
		onCreate,
		patientId,
		defaultValues,
		attachToDiscourse = false,
		discardOnClose = false,
		createDekurz,
	} = props;
	const { isCase } = useTreatmentContext();

	const handleClose = () => {
		onClose?.();
	};

	return (
		<>
			<Modal
				opened={opened}
				onClose={handleClose}
				wrapChat={isCase}
				size={Size.XL}>
				<Modal.Header
					closeButton={<ElectronicPrescriptionCloseButton onClose={handleClose} />}
					title={'base.electronicPrescription'}
				/>
				<Modal.Content contentScroll={true}>
					<ElectronicPrescriptionDetailWrapper
						patientId={patientId}
						onClose={handleClose}
						onCreate={onCreate}
						defaultValues={defaultValues}
						attachToDiscourse={attachToDiscourse}
						createDekurz={createDekurz}
					/>
				</Modal.Content>
			</Modal>
		</>
	);
}
